import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-biaoti1",
  "use": "icon-biaoti1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-biaoti1\"><path d=\"M554.666667 853.333333h-85.333334v-298.666666H170.666667v298.666666H85.333333V170.666667h85.333334v298.666666h298.666666V170.666667h85.333334v682.666666z m341.333333-512v512h-85.333333v-417.962666l-85.333334 22.869333V369.92L832 341.333333H896z\" p-id=\"2550\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol